import { SCM } from './root/SCM';

/**
 * Application entry point
 *
 * Customize Atomic SCM by passing props to the SCM component:
 *  - contactGender
 *  - companySectors
 *  - darkTheme
 *  - dealCategories
 *  - dealPipelineStatuses
 *  - dealStages
 *  - lightTheme
 *  - logo
 *  - noteStatuses
 *  - title
 * ... as well as all the props accepted by react-admin's <Admin> component.
 *
 * @example
 * const App = () => (
 *    <SCM
 *       logo="./img/logo.png"
 *       title="Acme SCM"
 *    />
 * );
 */
const App = () => <SCM />;

export default App;
